import { useState } from "react";
import axiosClient from "../common/api/request";

const useInviteFriend = (closeModal, from, type = "") => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const sendInvitation = () => {
    setLoading(true);
    const payload = { email, message };
    if (type) {
      payload.contact_type = type;
    }
    axiosClient
      .post(type ? "contact-us/" : "invitations/", payload)
      .then((res) => {
        setSuccess(res.detail || "Your message has been sent successfully!");
        setTimeout(() => {
          setSuccess("");
          setEmail("");
          setMessage("");
          closeModal();
        }, 3000);
      })
      .catch(() => {
        closeModal();
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return {
    email,
    loading,
    success,
    setEmail,
    message,
    setMessage,
    sendInvitation,
  };
};

export default useInviteFriend;
